import { styled } from '@mui/material';

export const StyledChemicalCompositionGrid = styled('div')(({ theme }) => ({
  gap: theme.spacing(2),
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, max(120px))'
}));
